export default {
  benefits: [
    {
      img: require('@/assets/images/3.png'),
      text: 'Increase sex lasting'
    },
    {
      img: require('@/assets/images/4.png'),
      text: 'Improve erectile strength'
    },
    {
      img: require('@/assets/images/5.png'),
      text: 'Enhance and intensify orgasms'
    }
  ],
  not_all_block: [
    {
      img: require('@/assets/images/6.png'),
      text: 'Potential for multiple and no-ejaculatory orgasms'
    },
    {
      img: require('@/assets/images/7.png'),
      text: 'Boosted libido'
    },
    {
      img: require('@/assets/images/8.png'),
      text: 'Prevented prostatitis and hemorrhoids'
    },
    {
      img: require('@/assets/images/9.png'),
      text: 'Increased self-confidence'
    },
    {
      img: require('@/assets/images/10.png'),
      text: 'Increased bladder and bowel control'
    },
    {
      img: require('@/assets/images/11.png'),
      text: 'Strengthened core and lower body muscles'
    }
  ],
  sliders: [
    {
      id: 1,
      text: '82,5% of patients who suffered from premature ejaculation have increased their sex lasting by 253% in 2,7 months of Kegel exercises. They were tested 6 months later and the result was the same',
      info: {
        title: 'National Center for Biotechnology Information',
        discription: 'https://www.ncbi.nlm.nih.gov/',
        link: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4003840/',
        img: require('@/assets/images/png1.png')
      }
    },
    {
      id: 2,
      text: '75,5% of men that suffered erectile dysfunction, have significantly improved their erectile function after 6 months of Kegel exercises. The Somerset Nuffield Hospital. ',
      info: {
        title: 'Wiley Online Library - BJU International',
        discription: 'https://bjui-journals.onlinelibrary.wiley.com/',
        link: 'https://bjui-journals.onlinelibrary.wiley.com/doi/full/10.1111/j.1464-410X.2005.05690.x',
        img: require('@/assets/images/png2.png')
      }
    },
    {
      id: 3,
      text: '71% of men that suffered erectile dysfunction, have significantly improved their erectile function after 6 months of Kegel exercises. Department of Urology at University Hospital, Katholieke Universiteit Leuven, Leuven, Belgium.',
      info: {
        title: 'Oxford Academic Journals',
        discription: 'https://academic.oup.com/',
        link: 'https://academic.oup.com/ptj/article/83/6/536/2805269',
        img: require('@/assets/images/png3.png')
      }
    },
    {
      id: 4,
      text: 'Kegel exercises have been tested for centuries. Hippocrates and Galen described that PF muscle exercises were performed in Greeks and Romans baths. It was thought that they promote general and sexual health, spirituality, and longevity',
      info: {
        title: 'Pelvic Floor Muscle Training in Males: Practical Applications',
        discription: 'https://cdn.shopify.com/',
        link: 'https://cdn.shopify.com/s/files/1/0077/8282/6074/files/Pelvic_Floor_Muscle_Training_in_Males-_Practical_Applications.pdf?3156',
        img: require('@/assets/images/png4.png')
      }
    },
    {
      id: 5,
      text: '61% of patients who suffered from premature ejaculation were cured and are able to control the ejaculatory reflex after After 15–20 sessions of Kegel exercises',
      info: {
        title: 'Taylor & Francis Online',
        discription: 'https://www.tandfonline.com/',
        link: 'https://www.tandfonline.com/doi/abs/10.1080/00926239608405302',
        img: require('@/assets/images/png5.png')
      }
    },
    {
      id: 6,
      text: '57% of patients who suffered from premature ejaculation have increased their sex lasting by 240% in 3 months of Kegel exercises. The result was almost the same as when taking Dapoxetine.',
      info: {
        title: 'Wiley Online Library',
        discription: 'https://onlinelibrary.wiley.com/',
        link: 'https://onlinelibrary.wiley.com/doi/full/10.1111/j.1365-2605.2011.01243.x',
        img: require('@/assets/images/png6.png')
      }
    },
    {
      id: 7,
      text: '72% of patients with Chronic prostatitis/chronic pelvic pain syndrome had improvement after Kegel exercises',
      info: {
        title: 'ScienceDirect.com',
        discription: 'https://www.sciencedirect.com/',
        link: 'https://www.sciencedirect.com/science/article/pii/S0090429502023907',
        img: require('@/assets/images/png7.png')
      }
    },
    {
      id: 8,
      text: '88% of patients with stress urinary incontinence (SUI) achieved continence in 3 months of Kegel exercises',
      info: {
        title: 'ScienceDirect.com',
        discription: 'https://www.sciencedirect.com/',
        link: 'https://www.sciencedirect.com/science/article/abs/pii/S014067369903473X',
        img: require('@/assets/images/png7.png')
      }
    },
    {
      id: 9,
      text: 'Pelvic floor muscle training may act to optimize ejaculatory volume, force, and intensity of sexual climax ',
      info: {
        title: 'The Journal of Sexual Medicine',
        discription: 'https://www.smr.jsexmed.org/',
        link: 'https://www.smr.jsexmed.org/article/S2050-0521(15)00002-5/pdf',
        img: require('@/assets/images/png8.png')
      }
    },
    {
      id: 10,
      text: 'Pelvic floor muscle training may prove helpful in: stress urinary incontinence that follows prostate surgery, overactive bladder, postvoid dribbling, erectile dysfunction, premature ejaculation, and pelvic pain.',
      info: {
        title: 'ScienceDirect.com',
        discription: 'https://www.sciencedirect.com/',
        link: 'https://www.sciencedirect.com/science/article/abs/pii/S0090429514002738',
        img: require('@/assets/images/png7.png')
      }
    },
    {
      id: 11,
      text: '82% of the patients with post-radical prostatectomy incontinence regained continence 12 months of Kegel exercises',
      info: {
        title: 'ScienceDirect.com',
        discription: 'https://www.sciencedirect.com/',
        link: 'https://www.sciencedirect.com/science/article/abs/pii/S0022534705634520',
        img: require('@/assets/images/png7.png')
      }
    },
  ],
  questions_blocks: [
    [
      {
        title: 'What do Kegel exercises give?',
        text: '• Increased sex lasting<br>' +
          '• Improved erectile strength<br>' +
          '• Enhance and intensify orgasms<br>' +
          '• Potential for multiple and no-ejaculatory orgasms<br>' +
          '• Boosted libido<br>' +
          '• Increased self-confidence<br>' +
          '• Prevention of prostatitis and hemorrhoids<br>' +
          '• Increased bladder and bowel control<br>' +
          '• Strengthened core, legs and buttocks muscles',
      },
      {
        title: 'How to find the right muscles?',
        text: 'Pretend that you are urinating, then try to stop the flow with a quick muscle contraction. Those muscles you just used are the right muscles.',
      },
      {
        title: 'How to prepare for the exercises?',
        text: 'Empty your bladder and you\'re good to go.',
      },
    ],
    [
      {
        title: 'What are the nuances?',
        text: 'While doing the exercises, your glutes and abdominal muscles may automatically tense up. Try to control this. During the pelvic floor muscles tension, the other muscles should be relaxed: so you will avoid a muscle strain and spasms.',
      },
      {
        title: 'How long does it take to train?',
        text: 'You will see the first results in a month and a half of regular training. Exercise twice a day or more for high efficiency.',
      },
      {
        title: 'How to perform the exercises?',
        text: 'These exercises can be performed unnoticeable. Take a comfortable position. Doesn’t matter sitting, lying or standing, just not while walking. Remember to breathe. Otherwise, you will get tired faster, and the benefits of such exercises will decrease.',
      },
    ]
  ],
  navbar: [
    {
      link: '#Overview',
      text: 'Overview'
    },
    {
      link: '#Benefits',
      text: 'Benefits'
    },
    {
      link: '#Features',
      text: 'Features'
    },
    {
      link: '#FAQ',
      text: 'FAQ'
    }
  ],
  appFeatures: [
    {
      type: 'image-block',
      titleImg: require('@/assets/images/num1.png'),
      title: 'Main Training Program',
      class: 'block-1',
      reverse: false,
      textBlocks: [
        {
          img: require('@/assets/images/superhero-1.png'),
          title: 'Zero to hero ultimate plan',
          text: 'Main training program consists of an effective 12-month daily training plan. It’s aimed at concentrated training of the Pelvic Floor muscles. These training sessions include a huge number of different exercises with increasing difficulty, so you won’t get bored.',
        },
        {
          img: require('@/assets/images/incognito-1.png'),
          title: 'Exercise anywhere',
          text: 'A key feature of these exercises is that you can do them unnoticeable to the others: while standing in the line, lying on the beach or sitting in the office. Just start your training and a special tuned vibration will tell you how to perform the exercises correctly.',
        }
      ],
      mainImg: require('@/assets/images/12.png')
    },
    {
      type: 'image-block',
      titleImg: require('@/assets/images/num2.png'),
      title: 'Kegel Fitness',
      class: 'block-2',
      reverse: true,
      textBlocks: [
        {
          img: require('@/assets/images/strong-1.png'),
          title: 'Comprehensive sexual muscle workout',
          text: 'Kegel Fitness module includes special fitness exercises that strengthen not only pelvic floor muscles in an additional way, but also core and lower body muscles, which also play an important role in sexual and overall health. Different training program for every day of the week is beginner-friendly. The exercises are easy to perform at home and their difficulty increases as you progress.',
        },
        {
          img: require('@/assets/images/coach-1.png'),
          title: 'Personal trainer on your phone',
          text: 'There is a special video & audio instructions for each exercise from our trainer. With their help, you can be sure that you will perform the exercise correctly.',
        }
      ],
      mainImg: require('@/assets/images/13.png')
    },
    {
      type: 'title-block',
      titleText: 'Combine Kegel Fitness and Main Training Program to multiply the effect of your workouts.',
      buttonText: 'Try 7 days for free',
      bgImage: require('@/assets/images/group-131.png')
    },
    {
      type: 'image-block',
      titleImg: require('@/assets/images/num3.png'),
      manyImg: true,
      title: 'Daily Challenges',
      class: 'block-3',
      reverse: false,
      textBlocks: [
        {
          img: require('@/assets/images/heart-icon.png'),
          title: 'Test Your Willpower & Improve Health at the Same Time',
          text: 'A team of specialists has spent more than 200 hour for studying researches from the National Center for Biotechnology Information to form a set of effective challenges that affect the human body the most. By completing these challenges daily you will form powerful, useful habits that will help you improve your sexual and overall health in a shortest possible time.',
        }
      ],
      mainImg: require('@/assets/images/14.png')
    },
    {
      type: 'image-block',
      titleImg: require('@/assets/images/num4.png'),
      title: 'Progress Tracker',
      class: 'block-4',
      reverse: true,
      textBlocks: [
        {
          img: require('@/assets/images/report-1.png'),
          title: 'Monitor Real Training Effect',
          text: 'Take regular muscle measurements <br>See how your muscles become stronger<br> Increase your motivation and achieve greater results.',
          buttonText: 'Try For Free',
        }
      ],
      mainImg: require('@/assets/images/15.png')
    },
  ],
  footer_navigation: [
    {
      title: 'Navigation',
      links: [
        {
          link: '#Overview',
          text: 'Overview'
        },
        {
          link: '#Benefits',
          text: 'Benefits'
        },
        {
          link: '#Features',
          text: 'Features'
        },
        {
          link: '#FAQ',
          text: 'FAQ'
        }
      ]
    },
    {
      title: 'Legal',
      links: [
        {
          text: 'Privacy Policy',
          link: 'http://appercut.co/privacy-policy.html'
        },
        {
          text: 'Terms of Service',
          link: ''
        },
      ]
    },
    {
      title: 'Contact',
      links: [
        {
          text: 'support@kegel.men',
          link: 'mailto:support@kegel.men'
        },
      ]
    }
  ]
}